import React, { useState } from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import LitStructuredText from './generic/LitStructuredText';
import LitImage from './images/LitImage';
import CustomerReview from './CustomerReview';
const ModularCardGrid = ({ data }) => {
  const [showMore, setShowMore] = useState(false);

  const {
    cardGridContent,
    heading,
    buttonText,
    buttonPath,
    backgroundColor,
    isTrustpilot,
  } = data;
  const cardGridContentLength = showMore
    ? cardGridContent
    : cardGridContent.slice(0, 3);

  return (
    <div className={`modular-card-grid-container ${backgroundColor}`}>
      <div className="modular-card-grid-inner modular-padding-large">
        {!isTrustpilot ? (
          <>
            <div className="modular-card-grid-heading">
              <LitStructuredText data={heading} basic />
            </div>
            <div className="modular-card-grid">
              {cardGridContentLength.map(({ card, imageBanner }, index) => {
                const {
                  jobTitle,
                  location,
                  previewImage,
                  previewText,
                  publishedDate,
                  slug,
                  category,
                  internal,
                } = card[0];

                return (
                  <div className="card" key={index}>
                    <LitImage
                      image={previewImage ?? imageBanner}
                      alt="job banner"
                    />
                    <div className="card-content">
                      <p className="card-location">
                        {location ?? category.name}
                      </p>
                      <h4 className="card-title">{jobTitle}</h4>
                      <p className="card-preview-text">{previewText}</p>

                      <p className="card-date-salary">
                        {new Date(publishedDate).toLocaleDateString('en-GB')}
                      </p>
                      <Link
                        to={
                          internal.type === 'DatoCmsJobVacancyModel'
                            ? `/careers/${slug}`
                            : `/blog/${slug}`
                        }
                        className="button"
                      >
                        Read more
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <CustomerReview
            isGrid
            showMore={showMore}
            setShowMore={setShowMore}
          />
        )}
        {!buttonText ? (
          <button
            className="button-blue modular-text-center"
            onClick={() => {
              setShowMore(!showMore);
            }}
          >
            {showMore ? 'Read less' : 'Read more'}
          </button>
        ) : (
          <Link className="button-blue" to={buttonPath}>
            {buttonText}
          </Link>
        )}
      </div>
    </div>
  );
};
export default ModularCardGrid;

export const fragment = graphql`
  fragment ModularCardGrid on DatoCmsCardGrid {
    internal {
      type
    }
    id
    heading {
      value
    }
    backgroundColor
    buttonPath
    buttonText
    isTrustpilot
    cardGridContent {
      imageBanner {
        gatsbyImageData
      }
      card {
        ... on DatoCmsJobVacancyModel {
          internal {
            type
          }
          id
          slug
          publishedDate
          previewText
          jobTitle
          location
          deadline
          content {
            value
          }
          previewImage {
            gatsbyImageData
          }
        }
        ... on DatoCmsBlogArticleModel {
          internal {
            type
          }
          id
          slug
          publishedDate
          previewText
          category {
            name
          }
          content {
            value
          }
          previewImage {
            gatsbyImageData
          }
        }
      }
    }
  }
`;
